import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'
import PageTracker from '../../../../common/PageTrackerHelper'
import {
  BasicSelect
} from 'vue-search-select';
export default {
  name: 'ShipmentScanTallyReport',
  components: {
      VueElementLoading,
      Paginate,
      BasicSelect
  },
  mixins:[PageTracker],
  data: function() {
      return {
        hubZoneList: [],
        hubList : [],
        reportData : [],
        hubzoneid : '',
        hubID : '',
        batchType : 'ScanTally',
        scanDate :'',
        tableLoading: false,
        csvRows: [],
        getUserHubZoneDetails: {},
        getShipmentList: [],
        ShipmentDetailsLoading: false,
        hubIDobj : { value: "",text: ""},
        zonename:'',
        zoneid:'',
        allhublist:[],
        scanTallyHubID : '',
        userDataKey : '',
      }
  },
  created: function() {
    this.getHubZoneData()
    this.getHubList("hubList");
    this.changeDateFormat();
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userid = userdetail.userid
    this.username = userdetail.username
    this.hubID = userdetail.hubdetails[0]
    //this.getHubzoneIDByHubID(this.hubID);
    this.getUserHubZoneDetails = await this.getHubDetailsbyID(this.userid,this.hubID);
    // this.hubIDobj = {
    //   text : this.getUserHubZoneDetails.HubName,
    //   value : this.getUserHubZoneDetails.HubID
    // }
    // this.hubID = this.getUserHubZoneDetails.HubID;
    this.hubzoneid ={
      id : this.getUserHubZoneDetails.HubZoneId,
      text : this.getUserHubZoneDetails.hubzonename
    }
    this.zonename = this.hubzoneid.text;
    this.zoneid = this.hubzoneid.id;
  },
  methods : {
    getHubZoneData() {
      axios.get(apiUrl.api_url + 'external/gethubzonelist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubZoneList=response.data.data;
            }
            else {
                this.hubZoneList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.error("hubzone data not found");
              console.error('exception is:::::::::', httpException)
        })
    },
    getHubzoneIDByHubID(hubid){
      this.tableLoading = true;
      axios.post(apiUrl.api_url + 'external/hubservicecenter/hubarray/get/hubzoneid', { "hubids" : [parseInt(hubid)]})
      .then(result => {
        this.tableLoading = false;
        const hubId = (this.hubID).toString()
          if (result.data.code === 200){
            this.hubzoneid = result.data.data[hubId]
      //      this.getHubListByZone();
          } else{
            this.hubzoneid = '';
          }
      }).catch(err => {
        this.$alertify.error("Zone data not found");
        console.error('exception is:::::::::::', err)
        return false;
      })
    },
    getHubListByZone(){
      axios.get(apiUrl.api_url + 'external/getzonewisehublist?zoneid=' + parseInt(this.hubzoneid))
      .then( async result => {
        this.tableLoading = false;
        await result.data.data.forEach(async(item, i) => {
          await this.hubList.push({
            value : item.HubID,
            text : item.HubName
          })
        });
      }).catch( err => {
        this.$alertify.error("Hub list not found");
        console.error("exception is:::::::::", err);
        return false
      })
    },
    validateForm(scope) {
      this.reportData = []
      this.$validator.validateAll(scope).then(result => {
        if(result) {
          this.getScanTallyRecords();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
   getScanTallyRecords(){
      this.reportData = [];
      this.tableLoading = true;
      let data = {
        BatchType : this.batchType,
        ScanDate : this.scanDate,
        ScanTallyAt : 'servicecenter'
      };
      if(this.zoneid != '') data.HubZoneID = this.zoneid;
      if(this.scanTallyHubID != '') data.HubID = this.scanTallyHubID;

      axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/shipmentReport',data)
        .then( (response) => {
          this.tableLoading = false
            if(response.data.code == 200){
                if(response.data.data.length > 0){
                  $.each(response.data.data, (key,value) => {
                    value = Object.assign({ BatchType: this.batchType }, value);
                //    value = Object.assign({ HubName: this.getUserHubZoneDetails.HubName }, value);
                    value = Object.assign({ HubZoneName: this.zonename }, value);
                    let hubname = this.hubList.filter(function(hub){
                      if(value.HubID == hub.value){
                        return hub;
                      }
                    })
                     value = Object.assign({ HubName: hubname[0].text }, value);
                    this.reportData.push(value);
                  })
                  console.log("tableData -- ",this.reportData);
                }else {
                    this.$alertify.error("No Records to Show!!!!!");
                }
            }
            else {
                this.$alertify.error(response.data.message);
            }
        })
        .catch((httpException) => {
              this.tableLoading = false
              this.$alertify.error("Error geting Report");
              console.error('exception is:::::::::', httpException)
        })
    },
    getHubList(hubZoneID){
      let url = 'UpdateShipment/gethublist';
      if(hubZoneID != 'hubList') url = `external/getzonewisehublist?zoneid=${hubZoneID}`;
      axios.get(apiUrl.api_url + url)
        .then(async(response) => {
            if(response.data.code ==200){
                await response.data.data.forEach(async(item, i) => {
                  await this.hubList.push({
                    value : item.HubID,
                    text : item.HubName
                  })
                });
                this.hubList.sort(function(sortFirst, sortSecond){
                 var hubNameFirst = sortFirst.text.toLowerCase(), hubNameSecond = sortSecond.text.toLowerCase()
                 if (hubNameFirst < hubNameSecond) //sort string ascending
                  return -1
                 if (hubNameFirst > hubNameSecond)
                  return 1
                 return 0 //default return value (no sorting)
                });
            }
            else {
                this.hubList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.error("Hub List not found");
              console.error('exception is:::::::::', httpException)
        })
    },
    exportAllData(data,num,fileName=""){
      var csvData;
      if (num == 1) {
        csvData =  this.reportData;
      }else {
        csvData = data;
      }
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      var csv;

      if(fileName !=""){
        filename = fileName + today + ".csv";
      } else {
        filename = "ScanTallyReports" + today + ".csv";
      }

      csv = this.convertArrayOfObjectsToCSV({
              data: csvData
            })
      // if (num == 1) {
      //     csv = this.convertArrayOfObjectsToCSV({
      //     data: csvData
      //   });
      // }else {
      //     csv = data
      // }
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link)
    },
    convertArrayOfObjectsToCSV(args) {
       var result, ctr, keys, columnDelimiter, lineDelimiter, data;
       data = args.data || null;
       if (data == null || !data.length) {
         return null;
       }
       columnDelimiter = args.columnDelimiter || ",";
       lineDelimiter = args.lineDelimiter || "\n";
       keys = Object.keys(data[0]).slice(0);
       result = "";
       result += keys.join(columnDelimiter);
       result += lineDelimiter;
       data.forEach(function(item) {
         ctr = 0;
         keys.forEach(function(key) {
           if (ctr > 0) result += columnDelimiter;
           if (item[key] != null) {
             result += '"' + item[key] + '"';
           }
           ctr++;
         });
         result += lineDelimiter;
       });
       return result;
     },
     downloadBatch(pendingScanTally,batchId,typeName,hubID){
       if (pendingScanTally == 0) {
         this.$alertify.error("No Pending ScanTally Shipments To Download")
         return false;
       }else {
         this.ShipmentDetailsLoading = true;
         let searchTypePayload = {
           "BatchId": batchId,
           "SearchType" : typeName,
           "HubId": hubID,
           "ShipmentType": "all",
           "ShipmentSubType": "all",
           "sourceOfAction": "report"
         }
         axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/new/getshipments', searchTypePayload)
          .then((response) => {
              if(response.data.code === 200){
                this.getShipmentList = response.data.data;
                let getshipmentObjDetails = [];
                const reg = /[`#$^'|~]/g;
                this.getShipmentList.forEach(function(item){
                  getshipmentObjDetails.push({
                    "ShippingID": item.ShippingID,
                    "ServiceType": item.ServiceType,
                    "BatchID":item.BatchID,
                    "Status":item.Status,
                    "ShipmentStatus" : item.ShipmentStatus,
                    "NotificationType" : item.NotificationType,
                    "DeliveryStatus": item.DeliveryStatus,
                    "HubID": item.HubID,
                    "CurrentHubId": item.CurrentHubId,
                    "FinalDestinationID": item.FinalDestinationID,
                    "IsReversePick": item.IsReversePick,
                    "IsSupplierPick": item.IsSupplierPick,
                    "IsDeliveryWithReversePickUp": '',
                    "ShipType": item.ShipType,
                    "IsInscan": item.IsInscan,
                    "IsOverage": item.IsOverage,
                    "CreatedBy": item.CreatedBy,
                    "CreatedDate": item.CreatedDate,
                    "LastModifiedBy": item.LastModifiedBy,
                    "LastModifiedDate": item.LastModifiedDate,
                    "CurrentHubName" : item.CurrentHubName,
                    "OctroiMRP" : item.OctroiMRP,
                    "NetPayment" : item.NetPayment,
                    "LastProcessDate" : item.LastProcessDate,
                    "ShippingDate" : item.ShippingDate,
                    "OrderType" : item.OrderType,
                    "GapDays" : item.GapDays,
                    "CompanyName": item.CompanyName,
                    "WHPOID": item.WHPOID != '' && item.WHPOID ? item.WHPOID.replace(reg, " @ ") : item.WHPOID,
                    // "ProductId": "",
                    // "ProductInfo": item.ProductInfo != '' && item.ProductInfo != null ? item.ProductInfo.replace(reg, " @ ") : item.ProductInfo,
                    // "ProductCategory": item.ProductCategory != '' && item.ProductCategory != null ? item.ProductCategory.replace(reg, " @ ") : item.ProductCategory,
                    "LastComments": item.LastComments != '' && item.LastComments != null ? item.LastComments.replace(reg, " @ ") : item.LastComments,
                    // "ShipPinCode": item.ShipPinCode,
                    // "ShipAddress": item.ShipAddress != '' && item.ShipAddress != null ? item.ShipAddress.replace(reg, " @ ") : item.ShipAddress,
                    "DeliveryStatusCode": item.DeliveryStatusCode,
                    // "RTOStatusCode": "",
                    "Comments" : item.Comments != '' && item.Comments != null ? item.Comments.replace(reg, " @ ") : item.Comments,
                    }
                  )
                });
              this.exportAllData(getshipmentObjDetails,2,'PendingScanTallyReports');

              } else if(response.data.code === 202){
                this.getShipmentList = [];
                this.$alertify.error("Unable to download csv");
              } else {
                this.getShipmentList = [];
                this.$alertify.error("Unable to download csv");
              }
              this.ShipmentDetailsLoading = false;
          })
          .catch((httpException) => {
              this.$alertify.error("Something went wrong while downloading csv");
              console.error('exception is:::::::::', httpException)
          })

          this.csvRows = [];

         // // get the headers
         // const headers = Object.keys(this.reportData[0]);
         // this.csvRows.push(headers.join(','));
         //
         // // loop over the rows
         // for (const row of singleBatchData){
         //   const values = headers.map(header => {
         //     const escaped = ('' + row[header]).replace(/"/g, '\\"');
         //     return `"${escaped}"`;
         //   });
         //   this.csvRows.push(values.join(','));
         // }
         //return this.exportAllData(this.csvRows.join('\n'),2)
         // return ;
       }
     },
     changeDateFormat(){
       let current_datetime = new Date()
       let formatted_date = current_datetime.getFullYear() + "-" + ("0" + (current_datetime.getMonth() + 1)).slice(-2) + "-" + ("0" + (current_datetime.getDate())).slice(-2);
       this.scanDate = formatted_date;
     },
    clear(){
      // this.getHubZoneData()
      // this.getHubList("hubList");
      // this.getHubzoneIDByHubID(this.hubID);
      this.changeDateFormat();
      // this.hubList = [];
      // this.hubZoneList = [];
      this.reportData = [];
      // this.hubzoneid = '';
      // document.getElementById('hubzoneid').value = ''
      // this.hubID = '';
      // document.getElementById('hubID').value = ''
      this.batchType = 'ScanTally';
      this.$validator.reset();
      this.errors.clear();
      this.hubID = '';
      this.hubIDobj = { value: "",text: ""}
      this.scanTallyHubID = "";
      // this.hubIDobj = {
      //   text : this.getUserHubZoneDetails.HubName,
      //   value : this.getUserHubZoneDetails.HubID
      // }
      this.hubzoneid ={
        id : this.getUserHubZoneDetails.HubZoneId,
        text : this.getUserHubZoneDetails.hubzonename
      }
    },
    changezone(event){
      this.zonename = this.hubzoneid.text;
      this.zoneid = this.hubzoneid.id;
      this.hubID = '';
      this.hubIDobj = { value: "",text: ""}
      this.hubList = []
      if(this.zoneid){
        this.getHubList(this.zoneid);
      }
    },
    selectHub(obj){
      this.hubIDobj = obj;
      this.scanTallyHubID = obj.value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ScanTally/ShipmentScanTallyReport/ShipmentScanTallyReport.component.js